export default {
  data() {
    return {}
  },
  methods: {
    randomString(encode = 36, number = -8) {
      return Math.random() // 生成随机数字,
        .toString(encode) // 转化成36进制
        .slice(number)
    },
    rulerCheck(type, data) {
      switch (type) {
        case "email":
          return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(data);
          break;
        case "phone":
          return /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9])\d{8}$/.test(data)
            || /\d{3}-\d{8}|\d{4}-\d{7}/.test(data)
            || /\d{8}|\d{7}/.test(data);
          break;
        default:
          return true;
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/js/mixin.js